export default ({ params, errors } = window.FORM_DATA) => {
  const {
    fullName = null,
    email = null,
    iban = null,
    idNumber = null,
    birthDate = null,
    licenseType = null,
    carType = null,
    carPlateNumbers = null,
    carPlateLetters = null,
    carSerialNumber = null
  } = params

  return {
    fullName,
    email,
    iban,
    idNumber,
    birthDate,
    licenseType,
    carType,
    carPlateNumbers,
    carPlateLetters,
    carSerialNumber,
    errors,
    submitDisabled: false,
    uploadsInProgress: 0,

    profilePic: {
      '@upload:start' () {
        this.submitDisabled = true
      },

      '@upload:finish' () {
        this.submitDisabled = false
      }
    },

    form: {
      '@submit' (event) {
        if (this.submitDisabled) {
          event.preventDefault()
        }
      },

      '@upload:start' () {
        this.uploadsInProgress++
        this.submitDisabled = this.uploadsInProgress > 0
      },

      '@upload:finish' () {
        this.uploadsInProgress--
        this.submitDisabled = this.uploadsInProgress > 0
      }
    }
  }
}
